import { rubricKey, rubricListKey } from '../keys'
import { useQueryClient } from '@tanstack/react-query'
import { type RecordingRubricListInput, type RubricData, type RubricId } from '@terros/common'

type RubricCacheOutput = {
  clearItem: (rubricId: RubricId) => void
  clearList: (input?: RecordingRubricListInput) => void
  setItem: (rubric: RubricData) => void
}

export function useRubricCache(): RubricCacheOutput {
  const queryClient = useQueryClient()
  return {
    clearItem: (rubricId: RubricId) => {
      queryClient.invalidateQueries({ queryKey: rubricKey(rubricId) })
    },
    clearList: (input?: RecordingRubricListInput) => {
      queryClient.invalidateQueries({ queryKey: rubricListKey(input) })
    },
    setItem: (rubric: RubricData) => {
      queryClient.setQueryData(rubricKey(rubric.rubricId), rubric)
    },
  }
}
